import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const CTA = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="relative bg-slate-900 text-white py-20 md:py-28 overflow-hidden">
      <div className="absolute -top-24 right-1/4 w-96 h-96 bg-violet-600/20 rounded-full blur-3xl" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-4 leading-tight">
          {t.cta.title}
        </h2>
        <p className="text-xl md:text-2xl mb-8 text-indigo-200 font-medium">
          {t.cta.subtitle}
        </p>
        <p className="text-lg md:text-xl mb-6 text-slate-300 max-w-2xl mx-auto leading-relaxed">
          {t.cta.description}
        </p>
        <p className="text-xl md:text-2xl font-bold mb-10 text-amber-400">
          {t.cta.highlight}
        </p>
        <div className="flex justify-center items-center">
          <a
            href="/s"
            className="bg-amber-400 hover:bg-amber-300 text-slate-900 font-bold py-4 px-10 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl"
          >
            {t.cta.button}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
